import React from 'react';
import { StarIcon } from 'lucide-react';
import { Pill } from './Pill';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.replace(/[^A-Za-z]/g, '').toUpperCase();
}
export function TestimonialsSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="testimonials-heading" data-id="element-151" data-mp="1r1m79y7q5ya3">
      <div className="mx-auto max-w-6xl px-6" data-id="element-152" data-mp="1d1umnempdjn4">
        <div className="text-center" data-id="element-153" data-mp="1d132r12gxaco">
          <Pill tone="rose" data-id="element-154" data-mp="1d47eqkm6dadw">Verified teachers</Pill>
          <h2 id="testimonials-heading" className="mx-auto mt-5 max-w-2xl font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-155" data-mp="1i1z4b7zckkex">
            What ballet teachers are already saying
          </h2>
        </div>

        <ul className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-156" data-mp="1839wy952uicx">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-rose-deep/20 bg-blush p-7" data-id="element-157" data-mp="2ygildxg0quf5">
              <div className="flex gap-1" aria-label="Rated 5 out of 5" data-id="element-158" data-mp="32eongs5wwltq">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-159" data-mp="2q39hkcd5nxd0" data-mpi={index} />)}
              </div>

              <blockquote className="mt-5 font-display text-xl leading-relaxed text-charcoal/90" data-id="element-160" data-mp="34q2oat8lzutl">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-7" data-id="element-161" data-mp="2c2gnttuoh6ay">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rose-light font-sans text-xs font-semibold tracking-wide text-wine" aria-hidden="true" data-id="element-162" data-mp="2c4jk2vmfbvo4">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-163" data-mp="2h109ru99ui3b">
                  <span className="block font-semibold text-charcoal" data-id="element-164" data-mp="1aniy5b6e9es">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-ash" data-id="element-165" data-mp="3sfx1jbwubled">
                    {testimonial.role}, {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}